import { ChangeDetectorRef, Component } from '@angular/core';
import { CustomerType } from 'src/app/enums/customer-type';
import { IWizard } from 'src/app/interfaces/iwizard';
import { WizardSteps } from 'src/app/interfaces/wizard-steps';
import { EnrollmentService } from 'src/app/services/enrollment.service';
import { GeneralService } from 'src/app/services/general.service';

@Component({
    selector: 'app-b-start',
    templateUrl: './b-start.component.html',
    styleUrls: ['./b-start.component.scss'],
    standalone: false
})
export class BStartComponent {
     public previouslyEnrolled: string = "na";
     public haveUSDOT: string = "na";
     public inUse: boolean = false;
     public inUseTesting: boolean = false;
     public testedDOT: boolean = false;

     public DOTisDurity: boolean = false;
     public DOTRegexIsValid: boolean = false;

     public wizardObj: IWizard = {
          steps: [
               { step: 1, text: 'Welcome' } as WizardSteps,
               { step: 2, text: 'Company Information' } as WizardSteps,
               { step: 3, text: 'User Accounts' } as WizardSteps,
               { step: 4, text: 'Review' } as WizardSteps,
               { step: 5, text: 'Contract Documents' } as WizardSteps,
               { step: 6, text: 'Submit' } as WizardSteps,
               { step: 7, text: 'Billing Information' } as WizardSteps
          ]
     }

     public customerType = CustomerType;

     constructor(public generalService: GeneralService, public enrollmentService: EnrollmentService) {
          this.enrollmentService.clearAll();
     }

     ngOnInit(): void {
          this.enrollmentService.clearLocal();
          this.enrollmentService.clearCustomer();
          setTimeout(() => this.scrollToTop(), 500);
     }

     scrollToTop() {
          window.scrollTo(0, 0);
     }

     openDocument(docName: string) {
          this.generalService.openDocument(docName);
     }

     clearInput() {
          this.haveUSDOT = "na";
          this.enrollmentService.newCustomer!.dotId = "";
     }

     testDot() {
          const regex: RegExp = /^([0-9]*)$/;
          this.DOTisDurity = true;
          this.DOTRegexIsValid = regex.test(this.enrollmentService.newCustomer!.dotId!);
          if (this.enrollmentService.newCustomer?.dotId !== '' && this.DOTRegexIsValid) {
               this.inUseTesting = true;
               const useTest = this.enrollmentService.testDOT(this.enrollmentService.newCustomer!.dotId!);
               useTest.subscribe(
                    response => {
                         this.testResponse(response)
                    },
                    error => {
                         console.error('Error:', error);
                    }
               );
          } else {
               this.inUseTesting = false;
               this.inUse = false;
               this.testedDOT = false;
          }
     }

     testResponse(response: any) {
          this.inUse = (response === "true");
          this.enrollmentService.newCustomer!.customerType = CustomerType.AH;
          this.inUseTesting = false;
          this.testedDOT = true;
     }

     pageValid(): boolean | null {
          //page is valid if. previouslyEnrolled = 'false';
          //customer has dotID and the ID is not in use;
          //customer does not have ID and CustomerType is AH or ISP or NotSure

          if (this.previouslyEnrolled !== 'false') {
               return false;
          }
          if (this.haveUSDOT === 'true' && (this.enrollmentService.newCustomer?.dotId === '' || !this.DOTRegexIsValid || this.inUse || this.inUseTesting)) {
               return false;
          }
          if ((this.haveUSDOT === 'false' || this.haveUSDOT === 'na') && this.enrollmentService.newCustomer!.customerType === CustomerType.NA) {
               return false;
          }

          return null;
     }

     translate(translationTag: string) {
          let translatedText: string = this.generalService.getTranslation(translationTag, 'root')
          if (translatedText === undefined) {
               translatedText = this.generalService.getTranslation(translationTag, 'root');
          }
          return translatedText;
     }
}
